// import { WinGISMap } from "../../createMap";
// import { conditionalMapOptions } from "../../WinGISMapPage";
// import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";

// let map = WinGISMap.map;

// export async function getExcludedLayerIds() {


//   await map.when(); 

//   await reactiveUtils.whenOnce(() => map.layers.updating === false);

//   const layerLoadedPromises = map.layers.items.map(layer => 
//     reactiveUtils.whenOnce(() => layer.loaded === true) 
//   );

//   await Promise.all(layerLoadedPromises); 

//   const processLayer = (layer, layerParams) => {
//     if (layerParams.identifyParameters?.excludedLayers) {
//       conditionalMapOptions.layers[layer.title].identifyParameters.excludedLayerIds = [];

//       const processSublayer = (sublayer, params) => {
//         if (params.identifyParameters.excludedLayers.includes(sublayer.title)) {
//           conditionalMapOptions.layers[layer.title].identifyParameters.excludedLayerIds.push(sublayer.id);
//         }

//         if (sublayer.sublayers) {
//           sublayer.sublayers.forEach(sub => processSublayer(sub, params));
//         }
//       };

//       if (layer.sublayers) {
//         layer.sublayers.forEach(sublayer => processSublayer(sublayer, layerParams));
//       }
//     }
//   };

//   map.layers.items.forEach(layer => {
//     const layerParams = conditionalMapOptions.layers[layer.title];
//     if (layerParams) {
//       processLayer(layer, layerParams);
//     }
//   });

//   for (const [key, value] of Object.entries(conditionalMapOptions.layers)) {
//     if (conditionalMapOptions?.layers[key]?.identifyParameters?.excludedLayers && (conditionalMapOptions.layers[key].identifyParameters.excludedLayerIds.length < conditionalMapOptions.layers[key].identifyParameters.excludedLayers.length)) {
//       console.error(`Excluded layers = ${value.identifyParameters.excludedLayers.length}, layers actually excluded = ${excludedLayerIds[key]?.length ?? 0}`);
//     }
//   }


// }

import { WinGISMap } from "../../createMap";
import { conditionalMapOptions } from "../../util/importConditions";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";

let map = WinGISMap.map;

export async function getExcludedLayerIds() {
  await map.when();

  const processSublayer = (sublayer, params) => {
    if (params.identifyParameters.excludedLayers.includes(sublayer.title)) {
      params.identifyParameters.excludedLayerIds.push(sublayer.id);
    }

    if (sublayer.sublayers) {
      sublayer.sublayers.forEach(sub => processSublayer(sub, params));
    }
  };

  const processLayer = (layer, layerParams) => {
    if (layerParams.identifyParameters?.excludedLayers) {
      layerParams.identifyParameters.excludedLayerIds = [];

      if (layer.sublayers) {
        layer.sublayers.forEach(sublayer => processSublayer(sublayer, layerParams));
      }
    }
  };

  for (const layer of map.layers.items) {
    reactiveUtils.whenOnce(() => layer.loaded).then(() => {
      const layerParams = conditionalMapOptions.layers[layer.title];
      if (layerParams) {
        processLayer(layer, layerParams);
      }

      // Check and log discrepancies in excluded layers
      const excludedLayerIds = layerParams?.identifyParameters?.excludedLayerIds || [];
      const excludedLayers = layerParams?.identifyParameters?.excludedLayers || [];
      if (excludedLayerIds.length < excludedLayers.length) {
        console.error(`Excluded layers = ${excludedLayers.length}, layers actually excluded = ${excludedLayerIds.length}`);
      }
    }).catch(error => {
      console.error(`Error processing layer ${layer.title}:`, error);
    });
  }
}
